import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faEllipsis,
  faPen,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { ArrowLeftToLine, ArrowRightToLine } from "lucide-react";
import classNames from "classnames/bind";
import styles from "../../AIChatbot.module.scss";

const cx = classNames.bind(styles);

export default function ChatSidebar({
  collapse,
  sessionsChat,
  sessionId,
  divRef,
  onToggleCollapse,
  onNewChatSession,
  onSelectSession,
  onRequestEdit,
  onRequestDelete,
}) {
  return (
    <nav className="navbar navbar-vertical navbar-expand-lg">
      <div className="navbar-collapse collapse show" id="navbarVerticalCollapse">
        {!collapse && (
          <div className={`navbar-vertical-content`}>
            <ul className="navbar-nav flex-column" id="navbarVerticalNav">
              <li className="nav-item">
                <div className="nav-item-wrapper">
                  <div
                    className="nav-link ps-2 pt-2 pb-2 d-flex align-items-center justify-content-between cursor-pointer mb-1"
                    style={{ border: "1px solid #eff2f6" }}
                    onClick={onNewChatSession}
                  >
                    <div>
                      <FontAwesomeIcon icon={faEdit} className="fs-8 me-2" />
                      <span className="pt-1 fs-8-1">New Chat</span>
                    </div>
                    <span className="pt-1 float-end fs-9" style={{ color: "#cdcdcd" }}>
                      Ctrl + Shift + O
                    </span>
                  </div>
                </div>
              </li>

              <li className="nav-item">
                {Object.keys(sessionsChat).map((classification) => (
                  <div key={classification}>
                    <p className="navbar-vertical-label">{classification}</p>
                    <hr className="navbar-vertical-line" />
                    {sessionsChat[classification].map((session) => (
                      <div
                        key={session.AwsChatSessionId}
                        className={cx(
                          `${session.SessionId === sessionId ? "active-session" : ""}`,
                          "nav-link ps-2 pt-1 pb-1 d-flex align-items-center cursor-pointer mb-1"
                        )}
                        onClick={() => onSelectSession(session)}
                      >
                        <span className={cx("session-title")}>{session.Title}</span>
                        <div className={cx("dropdown", "session-title-action")}>
                          <button
                            className="btn fs-10 btn-sm dropdown-toggle dropdown-caret-none transition-none"
                            type="button"
                            data-bs-toggle="dropdown"
                            data-boundary="window"
                            aria-haspopup="true"
                            aria-expanded="false"
                            data-bs-reference="parent"
                          >
                            <FontAwesomeIcon icon={faEllipsis} className="me-1" />
                          </button>

                          <div
                            className={cx(
                              "dropdown-menu-action",
                              "dropdown-menu",
                              "dropdown-menu-end",
                              "py-2"
                            )}
                          >
                            <span
                              className="dropdown-item"
                              onClick={() => onRequestEdit(session)}
                            >
                              Edit
                              <FontAwesomeIcon icon={faPen} className="float-end" />
                            </span>
                            <span className="dropdown-item" onClick={() => onRequestDelete()}>
                              Delete
                              <FontAwesomeIcon icon={faTrash} className="float-end" />
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ))}
              </li>
            </ul>
          </div>
        )}
      </div>

      <div className="navbar-vertical-footer" ref={divRef}>
        <button
          onClick={onToggleCollapse}
          className="btn navbar-vertical-toggle border-0 fw-semibold w-100 white-space-nowrap d-flex align-items-center"
        >
          <ArrowLeftToLine size={19} />
          <ArrowRightToLine size={19} />
          <span className="navbar-vertical-footer-text ms-2">Collapsed</span>
        </button>
      </div>
    </nav>
  );
}

